'use strict';

function reexport(foreignExport) {
  for (var key in foreignExport) {
    exports[key] = foreignExport[key];
  }
}

reexport(require('fpx'));
reexport(require('espo'));
reexport(require('emerge'));
reexport(require('./misc'));
reexport(require('./react'));


//////////////////
// WEBPACK FOOTER
// ./~/prax/dist/index.js
// module id = 594
// module chunks = 118